import _ from "lodash";

export const MODULE_ID = Object.freeze({
  UNDEFINED: -1,
  GLOBAL: 0,
  CARDIOLOGY: 1,
  ELECTRONIC_MEDICAL_RECORD: 2,
  PATIENT_MONITORING: 3,
  OUTPATIENT: 4,
  OBSTETRICS: 5,
  COMMUNICATIONS: 6,
  FEDERATED: 7,
});

export const MODULE_NAME = Object.freeze(_.invert(MODULE_ID));
